// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"b4e22","icon":"_4c936","input":"a2b26"};